<template>
  <!-- 帮帮-我的商机 -->
  <div class="firm-body">
    <div class="help-body">
      <!-- 标题 帮帮 -->
      <p class="title-Individual-center">
        我的商机 <i class="el-icon-arrow-right"></i>
        <span class="span-Individual-center">{{
          Select == "1"
            ? "智能匹配"
            : Select == "2"
            ? "分配商机"
            : Select == "3"
            ? "转发"
            : "已购"
        }}</span>
      </p>
      <!-- 内容 -->
      <div class="help-Content">
        <!-- 筛选  地区/类型/类别 -->
        <div class="screenContent" v-show="Fold == '1'">
          <div class="Content">
            <p class="ContentTitle city-ellipsis">地区：</p>
            <div class="address" style="margin-right: 30px;">
              <p class="orientation"></p>
              <p
                class="city firm-clickable"
                @click="dialogAddress = true"
              >
                {{ city }}
              </p>
            </div>
            <p class="ContentTitle">车辆性质：</p>
            <div class="VehicleNature">
              <p
                v-for="(item, index) in natureArr"
                :key="index"
                class="typeScreen"
                :class="item.id == natureSelect ? 'typeSelect' : ''"
                @click="handelNatureSelect(item)"
              >
                {{ item.name }}
              </p>
            </div>
            <div class="PackUp">
              <span class="firm-clickable" @click="handleFold">折叠</span>
              <i class="el-icon-arrow-up firm-clickable" @click="handleFold"></i>
            </div>
          </div>
          <div class="Content">
            <p class="ContentTitle">车辆类型：</p>
            <div class="ContentOptions">
              <p
                v-for="(item, index) in typeArr"
                :key="index"
                class="typeScreen"
                :class="item.val == typeSelect ? 'typeSelect' : ''"
                @click="handelType(item)"
              >
                {{ item.name }}
              </p>
              <div
                class="subdivideType"
                v-if="typeSelect != '0' && typeSelect != '5'"
              >
                <p
                  v-for="(item, index) in typeArr[typeSelect].child"
                  :key="index"
                  class="typeScreen"
                  :class="UploadTypeSelect == item.id ? 'typeSelect' : ''"
                  @click="handelUploadTypeSelect(item)"
                >
                  {{ item.name }}
                </p>
              </div>
            </div>
          </div>
          <div class="Content">
            <p class="ContentTitle">保险种类：</p>
            <div class="ContentOptions">
              <p
                v-for="(item, index) in categoryArr"
                :key="index"
                class="typeScreen"
                :class="item.Select == '1' ? 'typeSelect' : ''"
                @click="handelCategory(item)"
              >
                {{ item.name }}
              </p>
            </div>
          </div>
          <div class="Content">
            <p class="ContentTitle">意向投保：</p>
            <div class="ContentOptions">
              <p
                v-for="(item, index) in intentionArr"
                :key="index"
                class="typeScreen"
                :class="item.Select == '1' ? 'typeSelect' : ''"
                @click="handelGroupBooking(item)"
              >
                {{ item.name }}
              </p>
            </div>
          </div>
        </div>
        <div class="screenContent screenContent-fold" v-show="Fold != '1'">
          <p class="fold-title" >地区：</p>
          <p class="fold-Content city-ellipsis" style="margin-right: 30px;">{{ city }}</p>
          <p class="fold-title">车辆性质：</p>
          <p class="fold-Content">{{ FoldNature }}</p>
          <p class="fold-title">车辆类型：</p>
          <div class="multiple">
            <p>
              <span>{{ FoldType }}</span>
            </p>
          </div>
          <p class="fold-title">保险种类：</p>
          <div class="multiple">
            <p>
              <span v-for="(item, index) in FoldInsurance" :key="index">{{
                item
              }}</span>
            </p>
          </div>
          <p class="fold-title">意向投保：</p>
          <div class="multiple">
            <p>
              <span v-for="(item, index) in FoldIntention" :key="index">{{
                item
              }}</span>
            </p>
          </div>
          <div class="PackUp">
            <span class="firm-clickable" @click="handleFold">折叠</span>
            <i class="el-icon-arrow-down firm-clickable" @click="handleFold"></i>
          </div>
        </div>

        <!--  切换按钮 -->
        <div class="help-Toggle">
          <p
            v-for="(item, index) in filteredMenu"
            :key="index"
            :class="Select == item.id ? 'selectTog' : ''"
            @click="handelSelect(item)"
          >
            {{ item.name }}
          </p>
          <div v-if="Select == '2' || Select == '3' || Select == '4'">
            <p class="Download firm-clickable" @click="handleDownload">下载</p>
          </div>
        </div>
        <!-- 内容 -->
        <div class="Chance-Con">
          <Module
            :listArr="listArr"
            :Select="Select"
            :DownloadNum="DownloadNum"
            @handlePurchaseForward="handlePurchaseForward"
            @handelCheck="handelCheck"
          ></Module>
        </div>
        <!-- 分页 -->
        <div class="paging-box">
          <div class="paging">
            <paging
              :pagingObj="pagingObj"
              @handleCurrentChange="handleCurrentChange"
            ></paging>
          </div>
        </div>
      </div>
    </div>
    <Address
      :dialogAddress="dialogAddress"
      :cityName="city"
      :cityCode="cityCode"
      @handleClose="handleClose"
      @handleUnderstand="handleUnderstand"
      @store="store"
      @getGaoDe="getGaoDe"
    ></Address>
    <Download
      :dialogDownload="dialogDownload"
      @handleCloseDownload="dialogDownload = false"
      @handleDow="handleDowEx"
    ></Download>
  </div>
</template>

<script>
// 引入接口
import {
  postGetCarType, // 获取车辆类型
  postGetAllCarSafeCompany, // 获取汽车保险公司
  postGetCarSafeType, //获取保险种类
} from "../../../../assets/api/indexl";
// 引入接口
import {
  carSafeInfoForCompany, //企业车险商机-智能匹配列表
  carSafeInfoForCompanyAllocate, //企业车险商机-已分配列表
  carSafeInfoForCompanyForward, //企业车险商机-转发列表
  carSafeInfoForCompanyPaid, //企业车险商机-已购列表
  downloadCompanyCarSafeData, // 下载
} from "../../../../assets/api/firm/Opportunity";
import paging from "../../../../components/paging.vue"; // 分页
import Download from "./components/Download.vue"; // 下载
import Module from "./components/Module.vue"; // 模块
// 切换地址
import Address from "./components/Address.vue";
export default {
  data() {
    return {
      dialogAddress: false, // 切换地址
      dialogDownload: false, //下载弹窗
      natureArr: [
        { name: "全部", id: "" },
        { name: "个人", id: "0" },
        { name: "企业", id: "1" },
      ], //车辆性质
      natureSelect: "", // 车辆性质选择
      personageAndFirm: [
        {
          name: "智能匹配",
          id: "1",
          val: "my:business:opportunity:match:list",
        },
        {
          name: "分配商机",
          id: "2",
          val: "my:business:opportunity:allocate:list",
        },
        { name: "转发", id: "3", val: "my:business:opportunity:forward:list" },
        { name: "已购", id: "4", val: "my:business:opportunity:paid:list" },
      ], //切换
      filteredMenu: [], // 权限过滤后的菜单
      Select: "1", // 切换
      // child
      typeArr: [
        {
          name: "全部",
          val: "0",
          id: null,
        },
        {
          name: "客车",
          val: "1",
          child: [],
        },
        {
          name: "货车",
          val: "2",
          child: [],
        },
        {
          name: "摩托车",
          val: "3",
          child: [],
        },
        {
          name: "农用车",
          val: "4",
          child: [],
        },
        {
          name: "其他车辆",
          val: "5",
          id: 999,
        },
      ], // 筛选类型
      typeSelect: "0", // 筛选类型选中
      UploadTypeSelect: null, // 调用接口时传的车辆类型

      categoryArr: [], //保险类别
      category: [], //保险类别选中的
      intentionArr: [], // 意向投保
      intention: [], // 意向投保选中的

      pagingObj: {
        currentPage: 1, //当前页
        pageSize: 8, // 一页显示多少个
        totalDevice: 0, //用户总数
      }, // 分页
      Fold: "1", // 0隐藏  1展示
      listArr: [],
      city: "",
      cityCode: [], //地区code（数组）

      FoldNature: "全部", // 折叠后展示的 车辆性质
      FoldType: "全部", //折叠后展示的车辆类型
      FoldInsurance: [], //折叠后展示的保险种类
      FoldIntention: [], //折叠后展示的意向投保

      selectedData: [], //选中的下载
      DownloadNum: 0, //完毕传给子组件清空选择
      foldToggleLock: false, // 折叠切换短锁，避免连续触发造成抖动
    };
  },
  components: {
    // 分页
    paging,
    Module,
    Address,
    Download,
  },
  created() {
    this.initPermissionMenu(); // 权限过滤
    this.$bus &&
      this.$bus.$on("admin-permission-updated", this.initPermissionMenu);

    this.postGetCarType();
    this.postGetAllCarSafeCompany();
    this.postGetCarSafeType();
  },
  mounted() {},
  watch: {
    cityCode: {
      handler(newSs, old) {
        this.handelListData();
      },
      immediate: false,
    },
  },
  beforeDestroy() {
    this.$bus &&
      this.$bus.$off("admin-permission-updated", this.initPermissionMenu);
  },
  destroyed() {},
  methods: {
    normalizeAddressCode(code) {
      if (Array.isArray(code)) {
        return code.filter(
          (x) => x !== undefined && x !== null && String(x).trim() !== ""
        );
      }
      if (code === undefined || code === null || String(code).trim() === "") {
        return [];
      }
      return String(code)
        .split(",")
        .map((x) => x.trim())
        .filter((x) => x);
    },
    // ==================== 权限过滤菜单 ====================
    initPermissionMenu() {
      let permStr = localStorage.getItem("permissionCodes");
      let perm = [];
      try {
        perm = JSON.parse(permStr);
      } catch (e) {}

      this.filteredMenu = this.personageAndFirm.filter((item) => {
        return item.val && perm.includes(item.val);
      });

      const exist = this.filteredMenu.some((x) => x.id === this.Select);
      if (!exist && this.filteredMenu.length > 0) {
        this.Select = this.filteredMenu[0].id;
      }
      this.handelListData();
    },

    // 下载确认
    handleDowEx() {
      var data = {
        data: {
          recordIdList: this.selectedData,
          allocationType: this.Select == "2" ? 0 : this.Select == "3" ? 2 : 1,
        },
      };
      downloadCompanyCarSafeData(data).then((res) => {
        const link = document.createElement("a"); // 创建a标签
        let blob = new Blob([res], {
          type: "application/vnd.ms-excel;charset=UTF-8",
        }); // 设置文件类型
        const chineseText = "商机数据";
        link.href = URL.createObjectURL(blob); // 创建URL
        link.setAttribute("download", chineseText);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        this.DownloadNum++;
        this.selectedData = [];
        this.dialogDownload = false;
      });
    },
    // 勾选下载项
    handelCheck(val) {
      this.selectedData = val;
    },
    // 列表操作完成 刷新数据
    handlePurchaseForward() {
      this.handelListData();
    },
    // 获取定位城市
    getGaoDe(val) {
      this.city = val;
    },
    // 切换地址关闭弹窗
    handleClose() {
      this.dialogAddress = !this.dialogAddress;
    },
    // 切换地址弹窗确定
    handleUnderstand(city, code) {
      this.city = city;
      this.cityCode = this.normalizeAddressCode(code);
      this.dialogAddress = !this.dialogAddress;
      // cityCode 的 watch 已经会触发一次刷新，这里不重复调用
    },
    // 点击筛选车辆性质
    handelNatureSelect(item) {
      this.natureSelect = item.id;
      this.FoldNature = item.name;
      this.handelListData();
    },
    // 地址code存储完成刷新
    store(code) {
      this.cityCode = this.normalizeAddressCode(code);
    },
    //----------- 保险种类
    handelCategory(item) {
      if (item.Select == 1) {
        item.Select = 0;
        for (var i in this.category) {
          if (item.id == this.category[i]) {
            this.category.splice(i, 1);
            this.FoldInsurance.splice(i, 1);
            this.handelListData();
          }
        }
      } else {
        item.Select = 1;
        this.category[this.category.length++] = item.id;
        this.FoldInsurance[this.FoldInsurance.length++] = item.name;
        this.handelListData();
      }
    },
    // --------------------------意向投保---------------------
    handelGroupBooking(item) {
      if (item.Select == 1) {
        item.Select = 0;
        for (var i in this.intention) {
          if (item.id == this.intention[i]) {
            this.intention.splice(i, 1);
            this.FoldIntention.splice(i, 1);
            this.handelListData();
          }
        }
      } else {
        item.Select = 1;
        this.intention[this.intention.length++] = item.id;
        this.FoldIntention[this.FoldIntention.length++] = item.name;
        this.handelListData();
      }
    },
    // 调用 ---------------------获取车辆类型接口---------------------
    postGetCarType() {
      postGetCarType().then((res) => {
        if (res.code == 0) {
          this.typeArr[1].child = res.data.客车;
          this.typeArr[2].child = res.data.货车;
          this.typeArr[3].child = res.data.摩托车;
          this.typeArr[4].child = res.data.农用车;
        }
      });
    },
    // ----------------------获取汽车保险公司---------------
    async postGetAllCarSafeCompany() {
      const res = await postGetAllCarSafeCompany({ data: this.select });
      if (res.code == 0) {
        for (var i in res.data.list) {
          res.data.list[i].Select = 0;
        }
        this.intentionArr = res.data.list;
      }
    },
    // ----------------------获取保险种类---------------
    async postGetCarSafeType() {
      const res = await postGetCarSafeType();
      if (res.code == 0) {
        for (var i in res.data) {
          res.data[i].Select = 0;
        }
        this.categoryArr = res.data;
      }
    },
    // 下载
    handleDownload() {
      if (!this.$checkAction()) return;
      if (this.selectedData.length > 0) {
        this.dialogDownload = true;
      } else {
        this.$tool.PromptBox("error", "请选择要下载的数据");
      }
    },
    // 点击折叠
    handleFold() {
      if (this.foldToggleLock) return;
      this.foldToggleLock = true;
      const currentScrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop ||
        0;
      this.Fold = this.Fold == "0" ? "1" : "0";
      this.$nextTick(() => {
        window.scrollTo(0, currentScrollTop);
      });
      setTimeout(() => {
        this.foldToggleLock = false;
      }, 180);
    },
    // 车辆类型 点击选择
    handelType(item) {
      if (item.val == "0" || item.val == "5") {
        this.UploadTypeSelect = item.id;
        this.FoldType = item.name;
        this.handelListData();
      }
      this.typeSelect = item.val;
    },
    handelUploadTypeSelect(item) {
      this.UploadTypeSelect = item.id;
      this.FoldType = item.name;
      this.handelListData();
    },
    // 列表切换
    handelSelect(item) {
      this.listArr = [];
      this.pagingObj = {
        currentPage: 1,
        pageSize: 8,
        totalDevice: 0,
      };
      this.Select = item.id;
      this.handelListData();
    },
    // 调用列表接口
    handelListData() {
      if (this.Select == 1) {
        this.carSafeInfoForCompany();
      } else if (this.Select == 2) {
        this.carSafeInfoForCompanyAllocate();
      } else if (this.Select == 3) {
        this.carSafeInfoForCompanyForward();
      } else {
        this.carSafeInfoForCompanyPaid();
      }
    },
    // 智能匹配商机列表接口
    carSafeInfoForCompany() {
      var data = {
        data: {
          addressCode: this.cityCode,
          carOwnerType: this.natureSelect,
          carType: this.UploadTypeSelect,
          safeCompanyList: this.intention,
          safeTypeList: this.category,
        },
      };
      carSafeInfoForCompany(
        data,
        this.pagingObj.currentPage,
        this.pagingObj.pageSize
      ).then((res) => {
        this.listArr = res.data.list;
        this.pagingObj.totalDevice = res.data.total;
      });
    },
    //企业车险商机-已分配列表
    carSafeInfoForCompanyAllocate() {
      var data = {
        data: {
          addressCode: this.cityCode,
          carOwnerType: this.natureSelect,
          carType: this.UploadTypeSelect,
          safeCompanyList: this.intention,
          safeTypeList: this.category,
        },
      };
      carSafeInfoForCompanyAllocate(
        data,
        this.pagingObj.currentPage,
        this.pagingObj.pageSize
      ).then((res) => {
        this.listArr = res.data.list;
        this.pagingObj.totalDevice = res.data.total;
      });
    },
    // 企业车险商机-转发列表
    carSafeInfoForCompanyForward() {
      var data = {
        data: {
          addressCode: this.cityCode,
          carOwnerType: this.natureSelect,
          carType: this.UploadTypeSelect,
          safeCompanyList: this.intention,
          safeTypeList: this.category,
        },
      };
      carSafeInfoForCompanyForward(
        data,
        this.pagingObj.currentPage,
        this.pagingObj.pageSize
      ).then((res) => {
        this.listArr = res.data.list;
        this.pagingObj.totalDevice = res.data.total;
      });
    },
    //企业车险商机-已购列表
    carSafeInfoForCompanyPaid() {
      var data = {
        data: {
          addressCode: this.cityCode,
          carOwnerType: this.natureSelect,
          carType: this.UploadTypeSelect,
          safeCompanyList: this.intention,
          safeTypeList: this.category,
        },
      };
      carSafeInfoForCompanyPaid(
        data,
        this.pagingObj.currentPage,
        this.pagingObj.pageSize
      ).then((res) => {
        this.listArr = res.data.list;
        this.pagingObj.totalDevice = res.data.total;
      });
    },
    // 分页
    handleCurrentChange(val) {
      this.pagingObj.currentPage = val;
      this.handelListData();
    },
  },
};
</script>

<style scoped lang="less">
.el-icon-arrow-right {
  margin-left: 4px;
  margin-right: 4px;
}
.firm-body {
  width: 100%;
  flex: 1;
  height: 100%;
  display: flex;
  .help-body {
    min-width: 1200px;
    margin: 0 auto;
    margin-top: 20px;
    display: flex;
    flex-direction: column;
  }
}
//主体
.help-Content {
  width: 1140px;
  height: 100%;
  background: #ffffff;
  box-shadow: 0px 0px 3px 0px rgba(125, 125, 125, 0.5);
  border-radius: 5px;
  margin-top: 13px;
  margin-bottom: 20px;
  padding: 30px;
  font-family: PingFangSC-Medium;
  color: #333333;
  font-weight: 400;

  // 切换
  .help-Toggle {
    width: 100%;
    height: 35px;
    line-height: 35px;
    display: flex;
    p {
      width: 110px;
      height: 35px;
      background: #eeeeee;
      border-radius: 5px;
      font-size: 12px;
      color: #333333;
      cursor: pointer;
      margin-right: 10px;
      text-align: center;
    }
    .selectTog {
      background: rgba(97, 144, 232, 0.2);
      color: #409eff ;
    }
    div {
      flex: 1;
      display: flex;
      justify-content: flex-end;
      p {
        width: 100px;
        height: 35px;
        line-height: 35px;
        background: #409eff ;
        border-radius: 5px;
        font-size: 14px;
        color: #ffffff;
        margin-right: 20px;
      }
    }
  }
  // 筛选
  .screenContent {
    min-height: 20px;
    padding: 20px;
    margin-bottom: 30px;
    background: #ffffff;
    box-shadow: 0px 0px 5px 0px rgba(125, 125, 125, 0.5);
    border-radius: 10px;
    .Content {
      width: 1100px;
      min-height: 17px;
      display: flex;
      flex-wrap: wrap;
      font-size: 14px;
      color: #333300;
      // 定位地址
      .address {
        max-width: 200px;
        display: flex;
        margin-bottom: 30px;
        color: #409eff ;
        .orientation {
          width: 15px;
          height: 16px;
          margin-right: 5px;
          background-image: url("../../../../assets/imgs/dingwei@3x.svg");
          background-size: 100% 100%;
        }
        .city {
          flex: 1;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          text-decoration: underline;
          cursor: pointer;
        }
        p {
          cursor: pointer;
        }
      }
      // 车辆性质
      .VehicleNature {
        width: 200px;
        height: 17px;
        line-height: 17px;
        display: flex;
        margin-left: 10px;
      }
      .ContentOptions {
        flex: 1;
        display: flex;
        flex-wrap: wrap;
        position: relative;
        .subdivideType {
          min-width: 250px;
          height: 50px;
          padding-left: 20px;
          line-height: 50px;
          background: #ffffff;
          border-radius: 10px 10px 10px 10px;
          position: absolute;
          left: 400px;
          top: -15px;
          background-image: url("../../../../assets/imgs/img/tanchuang@2x.png");
          background-size: 100% 100%;
          display: flex;
        }
      }
    }
    // 筛选中文字样式
    .typeScreen {
      margin-right: 20px;
      margin-left: 10px;
      margin-bottom: 30px;
      cursor: pointer;
    }
    .typeSelect {
      color: #409eff ;
    }
  }
  // 展开收起按钮
  .PackUp {
    flex: 1;
    display: flex;
    justify-content: flex-end;
    color: #409eff ;
    cursor: pointer;
    i {
      margin-left: 5px;
    }
  }
  // 收起筛选
  .screenContent-fold {
    font-size: 14px;
    display: flex;
    p {
      height: 20px;
      line-height: 20px;
    }

    .city-ellipsis {
      max-width: 150px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .multiple {
      max-width: 130px;
      display: flex;
      margin-right: 40px;

      p {
        font-size: 14px;
        color: #409eff ;
        margin-right: 20px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        span {
          margin-right: 10px;
        }
      }
    }
    .fold-Content {
      color: #409eff ;
      margin-right: 50px;
    }
  }
  // 内容
  .Chance-Con {
    min-height: 300px;
    margin-top: 30px;
  }
}
// 分页
.paging-box {
  width: 100%;
  height: 22px;
  //   margin-top: 30px;
  display: flex;
  justify-content: flex-end;

  .paging {
    width: 90%;
    height: 100%;
    display: flex;
    justify-content: flex-end;
  }
}
</style>
